import { useMatomo } from '@datapunt/matomo-tracker-react';
import Box from '@mui/material/Box';
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import CookieConsent from './CookieConsent';
import ErrorBoundary from './ErrorBoundary';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import SkipLink from './SkipLink';
import { useCookies } from '../hooks/CookieProvider';

const Page = () => {
  const cookieConsent = useCookies();
  const location = useLocation();
  const { trackPageView } = useMatomo();
  const { isAccepted } = cookieConsent;

  React.useEffect(() => {
    let timer;
    if (isAccepted('statistics')) {
      // track page view in matomo
      timer = setTimeout(() => {
        trackPageView();
      }, 50);
    }
    return () => clearTimeout(timer);
  }, [isAccepted, location.pathname, trackPageView]);

  return <>
    <SkipLink />
    <Header />
    <Box
      component="main"
      id="main-content"
      tabIndex={-1}
      sx={{
        marginTop: '135px',
        '@media (max-width: 480px) and (max-height: 480px)': {
          marginTop: '64px',
        },
      }}
    >
      <ScrollToTop />
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
      <CookieConsent />
    </Box>
    <Footer />
  </>;
};

export default Page;
